<script lang="ts">
  import DistributorAccountApplicationPage from "@retailer/svelte/DistributorAccountApplication/Page.svelte";
  import { params, redirect } from "@roxi/routify";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  const applicationRes = async () => {
    let url;
    if ($params.vendor) {
      url = `/api/retailer/account_applications?sf_vendor_id=${$params.vendor}`;
    } else {
      url = "/api/retailer/account_applications/new";
    }
    try {
      let res = await HttpPromise({
        method: "GET",
        url: url,
      });
      if (res.application_id) {
        $redirect(`/apply/${res.application_id}`);
      }
      return res;
    } catch (e) {
      return {};
    }
  };

  const load = async () => {
    const promises = [applicationRes()];

    let results = await Promise.all(promises);

    return {
      application: results[0],
    };
  };

</script>

{#await load()}
  <Spinner />
{:then data}
  <DistributorAccountApplicationPage application={data.application} step={Number($params.step)} />
{/await}
